import { DeliveryInformation } from 'types/vehicleTypes'
import create from 'zustand'

interface IBiddingSidePanel {
  isOpen: boolean
  biddingVehicleInstanceId?: number
  setBiddingVehicleInstanceId: (vehicleInstanceId: number) => void

  deliveryInformation: DeliveryInformation | null
  setDeliveryInformation: (info: DeliveryInformation | null) => void
  selectedDeliveryPrice: number | null
  setSelectedDeliveryPrice: (price: number | null) => void
  otherChildId: number
  setOtherChildId: (id: number) => void
  isOther: boolean
  setIsOther: (isOther: boolean) => void
  reset: () => void
  isBuyItNow: boolean
  setIsBuyItNow: (isBuyItNow: boolean) => void
  isPurchaseExclusive: boolean
  setIsPurchaseExclusive: (isPurchaseExclusive: boolean) => void
  purchaseExclusiveVehicleIds: number[]
  addPurchaseExclusiveVehicle: (vehicleInstanceId: number) => void
  isPurchaseExclusiveVehicle: (vehicleInstanceId: number) => boolean
  hasTransportationSelected: boolean
  setHasTransportationSelected: (value: boolean) => void
  hasPaymentMethodSelected: boolean
  setHasPaymentMethodSelected: (value: boolean) => void
}

export const useBiddingSidePanel = create<IBiddingSidePanel>((set, get) => ({
  biddingVehicleInstanceId: null,
  isOpen: false,
  setBiddingVehicleInstanceId(id) {
    set((state) => ({
      ...state,
      biddingVehicleInstanceId: id,
      isOpen: !!id
    }))
  },

  deliveryInformation: null,
  setDeliveryInformation: (info) => set({ deliveryInformation: info }),
  selectedDeliveryPrice: null,
  setSelectedDeliveryPrice: (price) => set({ selectedDeliveryPrice: price }),
  otherChildId: 0,
  setOtherChildId: (id) => set({ otherChildId: id }),
  isOther: false,
  setIsOther: (value) => set({ isOther: value }),
  reset: () =>
    set({
      deliveryInformation: null,
      selectedDeliveryPrice: null,
      otherChildId: 0,
      isOther: false,
      isBuyItNow: false,
      isPurchaseExclusive: false
    }),
  isBuyItNow: false,
  setIsBuyItNow: (value) => set({ isBuyItNow: value }),
  isPurchaseExclusive: false,
  setIsPurchaseExclusive: (value) => set({ isPurchaseExclusive: value }),
  purchaseExclusiveVehicleIds: [],
  addPurchaseExclusiveVehicle: (vehicleInstanceId) =>
    set((state) => ({
      ...state,
      purchaseExclusiveVehicleIds: [...state.purchaseExclusiveVehicleIds, vehicleInstanceId]
    })),
  isPurchaseExclusiveVehicle: (vehicleInstanceId) => {
    return get().purchaseExclusiveVehicleIds.includes(vehicleInstanceId)
  },
  hasTransportationSelected: false,
  setHasTransportationSelected: (value) => set({ hasTransportationSelected: value }),
  hasPaymentMethodSelected: false,
  setHasPaymentMethodSelected: (value) => set({ hasPaymentMethodSelected: value })
}))
